<template>
  <div class="container">
    <main>
      <h1 class="page-title">プライバシーポリシー</h1>
      <div class="privacy-content">
        <p>お支度ボード（以下「当運営者」といいます。）は、当運営者が管理するサービス「お支度ボード」及び同サービスに関連するすべてのサービス（以下「本サービス」と総称します。）におけるユーザーについての個人情報を含むユーザーの情報（以下「ユーザー情報」といいます。）の取り扱いについて、以下の通りプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。</p>

        <h2>1. 当運営者が取得するユーザー情報</h2>
        <p>当運営者が、本サービスにおいて取得するユーザー情報は、以下の通りです。</p>
        <ol>
          <li>メールアドレスの情報<br>
          当運営者は、ユーザーが本サービスのアカウントを作成するにあたり、一定のメールアドレスの情報の提供をお願いしています。</li>
          <li>アクション情報<br>
          当運営者は、本サービスの利用に関するユーザーのアクションに関する情報を、その日時とともに収集いたします。</li>
          <li>本サービスの利用情報<br>
            <ul>
              <li>端末情報<br>
              当運営者は、ユーザーが利用する機器情報（OS、端末の個体識別情報、コンピュータ名等）を取得する場合があります。</li>
              <li>ログ情報<br>
              ユーザーが本サービスを利用した際の IP アドレス、ブラウザ種類、ブラウザ言語等の情報が自動で生成、保存されます。また、当運営者は、Cookie や JavaScript などの技術を利用し、ユーザーの行動履歴を取得することがあります。</li>
            </ul>
          </li>
        </ol>

        <h2>2. ユーザー情報の利用目的</h2>
        <p>当運営者は取得したユーザー情報を以下の目的で利用いたします。</p>
        <ol>
          <li>ユーザーごとにカスタマイズされたコンテンツの提供、広告の配信をするため</li>
          <li>利用規約違反その他本サービスの不正・不当利用に対する対応のため</li>
          <li>データ補助その他ユーザーが本サービスを円滑に利用できるようにするため</li>
          <li>本サービスの利用に関する統計データを作成するため</li>
          <li>ユーザーからのお問い合わせ等に対する対応のため</li>
          <li>本サービスに関する情報等を告知するため</li>
          <li>今後の本サービスに関する新企画立案を行い提供するため</li>
          <li>有料サービス利用時等における請求処理のため</li>
          <li>マーケティング調査及び分析のため</li>
          <li>その他本サービスに関するお知らせをしたり、必要に応じた連絡を行ったりするため</li>
          <li>その他、上記利用目的に付随する目的のため</li>
        </ol>

        <h2>3. ユーザー情報の第三者への提供</h2>
        <p>当運営者は、以下の場合を除き、ユーザー情報を第三者に提供することはありません。</p>
        <ol>
          <li>法令に基づく場合</li>
          <li>人の生命、身体または財産の保護のために必要がある場合</li>
          <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</li>
          <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</li>
          <li>業務委託先に対して、業務の遂行に必要な範囲内で提供する場合</li>
        </ol>

        <h2>4. ユーザー情報の管理</h2>
        <p>当運営者は、ユーザー情報の管理について、以下の通り定めます。</p>
        <ol>
          <li>ユーザー情報の利用目的の範囲内でのみ利用する。</li>
          <li>ユーザー情報の管理については、適切な管理を行う。</li>
          <li>ユーザー情報の漏洩、滅失、改ざん、不正アクセス等のリスクを常に監視し、適切な対応を行う。</li>
          <li>利用目的の達成に必要な期間、ユーザー情報を保持します。なお、この期間は当運営者の判断により適宜見直されることがあります。</li>
        </ol>

        <h2>5. ユーザー情報の開示・訂正・削除</h2>
        <p>ユーザーは、ユーザー情報の開示、訂正、削除等の要求をすることができます。この場合、当運営者は、合理的な範囲内でこれを行います。ただし、法令等により保管が必要な情報や、サービス提供に必要不可欠な情報については、ユーザーからの削除の要求に応じられない場合があります。</p>

        <h2>6. プライバシーポリシーの改定</h2>
        <p>当運営者は、ユーザー情報の取扱いについて継続的に改善するため、本ポリシーを改定することがあります。なお、法令上ユーザーの同意が必要となる内容の改定の場合は、当運営者所定の方法でユーザーの同意を得るものとします。</p>

        <h2>7. 免責事項</h2>
        <p>当運営者は、ユーザー情報の管理について万全を期しておりますが、予期せぬ事態により情報漏洩等が発生した場合、その責任を負いかねる場合があります。</p>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyView',
  mounted() {
    document.title = 'プライバシーポリシー | お支度ボードアプリ'
  }
}
</script>

<style>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.page-title {
  display: block;
  font-size: 2.5rem;
  margin-bottom: 2rem;
  font-weight: bold;
  color: #1a202c;
}

.privacy-content {
  max-width: none;
  text-align: left;
}

.privacy-content h2 {
  margin-top: 2em;
  margin-bottom: 1em;
  font-weight: bold;
}

.privacy-content p {
  margin-bottom: 1em;
  line-height: 1.8;
}

.privacy-content ol {
  margin-left: 1.5em;
  margin-bottom: 1em;
}

.privacy-content li {
  margin-bottom: 0.5em;
}

.privacy-content ul {
  list-style-type: disc;
  margin-left: 1.5em;
  margin-bottom: 1em;
}
</style> 